import Map from 'ol/Map';
import Overlay from 'ol/Overlay';

import {
    formatRadius,
    getDrawingCircleRadius,
    getHarvestCircle,
} from '../queries/harvest';

const makeLabelOverlay = () => {
    const element = document.createElement('div');
    element.className = 'harvest-map-label';
    const overlay = new Overlay({
        element,
        offset: [12, 0],
        positioning: 'center-left',
    });
    return { element, overlay };
};

/**
 * On-map radius labels for the circle harvester:
 *   - a cursor label following the pointer while placing the center (drawing);
 *   - a label anchored at the placed circle center (harvesting).

 */
export const harvestLabels = () => {
    const cursor = makeLabelOverlay();
    const center = makeLabelOverlay();

    const init = (map: Map) => {
        map.addOverlay(cursor.overlay);
        map.addOverlay(center.overlay);

        map.on('pointermove', event =>
            getDrawingCircleRadius().foldL(
                () => cursor.overlay.setPosition(undefined),
                radius => {
                    cursor.element.textContent = formatRadius(radius);
                    cursor.overlay.setPosition(event.coordinate);
                },
            ),
        );
    };

    const update = () =>
        getHarvestCircle().foldL(
            () => center.overlay.setPosition(undefined),
            ({ center: position, radius }) => {
                center.element.textContent = formatRadius(radius);
                center.overlay.setPosition(position);
            },
        );

    return { init, update };
};
